export default __webpack_public_path__ + "static/media/snake.70fc08eb.png";